import { BaseCliJsStepAction } from './baseCliJsStepAction';

export class CliConditionStepAction extends BaseCliJsStepAction {
    protected isFailedResult(resultValue: any) {
        return !resultValue;
    }
}
